import {UI} from "../../../stem-core/ui/UIBase";

import {styleRule, StyleSheet} from "../../../stem-core/ui/Style";
import {registerStyle} from "../../../stem-core/ui/style/Theme";
import {Link} from "../../../stem-core/ui/primitives/Link";
import {ExternalLinkIcon} from "../../../core/ui/SVGElements.jsx";
import type {ExtendedOptions} from "../../../stem-core/ui/UIBase";


class ExternalLinkStyle extends StyleSheet {
    @styleRule
    container = {
        fontWeight: "initial",
    };

    @styleRule
    icon = {
        marginLeft: 5,
        display: "inline-flex",
    };
}

interface ExternalLinkOptions {
    noIcon?: any;
}

@registerStyle(ExternalLinkStyle)
export class ExternalLink extends Link {
    // Link fixes its own options type and doesn't forward a type argument
    declare options: ExtendedOptions<Link, ExternalLinkOptions>;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            newTab: true,
            noIcon: false,
            label: "",
        };
    }

    getChildrenToRender() {
        return [
            this.render(),
            !this.options.noIcon && <ExternalLinkIcon className={this.styleSheet.icon}/>,
        ];
    }
}
